import React, { useState } from 'react'
import FeaturedItems from '../FeaturedItemSection/FeaturedItems'
import FeaturedProductSlider from './FeaturedProductsSlider'
import CbCarouselVertical from '../CbCarouselVertical/CbCarouselVertical';

const FeaturedProductsContainer = ({ containerObject, templateName, contentId, dataZone }) => {
    const [productViewType, setProductViewType] = useState(containerObject && containerObject.attributes && containerObject.attributes.productViewType ?  containerObject.attributes.productViewType : "horizontal");
    const [showInSlider, setShowInSlider] = useState(containerObject && containerObject.attributes && containerObject.attributes.showInSlider ?  containerObject.attributes.showInSlider : "false");
    
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row featuredProductContainer ${containerObject && containerObject.attributes && containerObject.attributes.className ? containerObject.attributes.className : ""} ${containerObject && containerObject.DO_NOT_DISPLAY	== false ? "featured-dont-display" :""} `} >
            
            

            {containerObject && containerObject.results && containerObject.results && containerObject.results.length >= 1 ? 
                showInSlider === "true" && productViewType === "horizontal" ?
                    <FeaturedProductSlider containerObject={containerObject} />
                    :
                    showInSlider === "true" && productViewType === "vertical" ?
                        <CbCarouselVertical containerObject={containerObject} />
                        :
                        <FeaturedItems containerObject={containerObject} />
                : ""}
        </div>
    )
}
export default FeaturedProductsContainer
